import { render, staticRenderFns } from "./WebCam.vue?vue&type=template&id=1ff3cc5c&scoped=true&"
import script from "./WebCam.vue?vue&type=script&lang=js&"
export * from "./WebCam.vue?vue&type=script&lang=js&"
import style0 from "./WebCam.vue?vue&type=style&index=0&id=1ff3cc5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff3cc5c",
  null
  
)

export default component.exports